import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {InfoBlockGrid} from '../InfoBlockGrid'

import './featured-articles.css'

const nArticlesPerRow = 2;
const nArticlesPerRowMobile = 1;

class FeaturedArticles extends Component {

  render () {
    let data = this.props.data;
    let sizes = this.props.sizes;
    let title = data.title ? <Title name = {data.title}></Title> : null;
    console.log(sizes);

    return (
      <div>
        {title}
        <InfoBlockGrid
          nCellsPerRow = {nArticlesPerRow}
          nCellsPerRowMobile = {nArticlesPerRowMobile}
          data = {data.articles}
          sizes = {sizes}
        ></InfoBlockGrid>
      </div>
    );
  }
}


export default {FeaturedArticles}



// WEBPACK FOOTER //
// ./src/components/FeaturedArticles/index.js